<div *ngIf = "!toggle">
<!-- <app-login-view (newItemEvent)="addItem($event)"></app-login-view> -->
<router-outlet></router-outlet>
</div>

<div *ngIf = "toggle" class="container-fluid h-100">
  <div class="row">
    <div class="col">
      <app-nav-menu></app-nav-menu>
      <!-- <button  class = "logout btn btn-info my-4 btn-block"(click) = "logout()">logout</button> -->
    </div>
  </div>
 
  <br />
  <div class="row h-80"  >
    <div class="col-md-2" style = "background-color: gainsboro; height : 75vh;padding: 0;">
      <app-sidenav></app-sidenav>

    </div>
    <div class="col-md-10">
      

      <router-outlet></router-outlet>
    </div>
    
    <div style = "position: relative">
      <app-footer></app-footer>

    </div>
   


  </div>

  <!-- <div class="row">
    <div class="col">
      <app-footer></app-footer>
    </div>
  </div> -->
</div>
<app-loaderr></app-loaderr>
<app-alert></app-alert>


